<header class="modal-header header">
  {{ (isEditing ? Localization.EditDetails : Localization.CreateNewInterventionTeam) | translate }}

  <a (click)="cancel()" aria-label="Close" class="close pull-right">
    <span aria-hidden="true">×</span>
  </a>
</header>
<main>
  <chapps-text-input [control]="nameField"
                     [label]="Localization.TeamName">
  </chapps-text-input>
</main>

<footer class="modal-footer justify-content-end">
  <chapps-secondary-button (clicked)="save()"
                           [disabled]="!canSave"
                           [label]="isEditing ? Localization.Save : Localization.Create"
                           [loading]="saving"
                           [small]="true">
  </chapps-secondary-button>
</footer>
